import React from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';

interface Props {
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  onChange: (value: boolean) => void;
}

export const SwitchLabel = ({
  checked,
  label = 'label',
  onChange,
  className,
  disabled = false
}: Props) => {
  return (
    <FormControlLabel
      className={className}
      disabled={disabled}
      control={
        <Switch
          size="medium"
          checked={checked}
          name="switch"
          color="primary"
          disabled={disabled}
          onChange={(e, val) => onChange(val)}
        />
      }
      label={label}
    />
  );
};
